import React from 'react';
import { withStyles, Typography, Grid } from '@material-ui/core';
import BottomLine from './BottomLine';

const styles = theme => ({
  sectionHeader: {
    paddingTop: theme.spacing.unit * 3
  },
  sup: {
    color: theme.palette.secondary.main,
    fontSize: 24
  }
});

const SectionHeader = class extends React.PureComponent {
  render() {
    const {
      text,
      classes,
      img,
      subtitle,
      subcolor,
      imgHeight,
      sup,
      ...other
    } = this.props;

    const ast = sup ? <sup className={classes.sup}>*</sup> : '';
    return (
      <Grid container direction="column" alignItems="center">
        <Grid item>
          <Typography
            {...other}
            className={classes.sectionHeader}
            align="center"
            variant="h2"
          >
            {text}
            {ast}{' '}
            <img
              src={`/images/assets/asset-${img}.png`}
              alt="asset"
              height={imgHeight}
            />
          </Typography>
        </Grid>
        <Grid item style={{ width: '100%' }}>
          <BottomLine />
        </Grid>
        <Grid item>
          <Typography
            variant="subtitle1"
            align="center"
            color={subcolor}
            style={{ marginBottom: '60px' }}
          >
            {subtitle}
          </Typography>
        </Grid>
      </Grid>
    );
  }
};

export default withStyles(styles)(SectionHeader);
